import React, { useContext, useEffect, useState } from 'react';
import { CalculationBuilderContext } from "../CalculationBuilderView";
import { Modal, Box, SpaceBetween, Button, KeyValuePairs, RadioGroup, FormField, ColumnLayout, Popover, Multiselect, Alert } from "@amzn/awsui-components-react";
import LinkedCLILink from '../calculation-templates/LinkedCLILink';
import StringUtils from 'src/utils/stringUtils';


export default function CloneToTherCLIsModal(props: {
        visible: boolean,
        isCloning: boolean,
        cloneError: string,
        onClose: () => void,
        onSubmit: (calculationNumber: string, cloneToAllCLIsInTemplate: boolean, selectedCLIs: string[] ) => void,
    }){
    const { visible, isCloning, cloneError, onClose: onModalClosed, onSubmit } = props;

    const { services, calcBuilderState, calcBuilderDispatch } = useContext(CalculationBuilderContext);
    const { calculationTemplateMetaData, linkedCLIs } = calcBuilderState;

    const [cloneType, setCloneType] = useState<string | null>(null);
    const [selectedOptions, setSelectedOptions] = useState([] as any[]);

    const onConfirmClicked = () => {
        onSubmit(calculationTemplateMetaData?.calculationNumber || '', cloneType === "all", selectedOptions.map(x => x.calculationNumber))
    }
    
    return <Modal
      onDismiss={onModalClosed}
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onModalClosed}>Cancel</Button>
            <Button variant="primary" disabled={cloneType == null || isCloning} onClick={onConfirmClicked}>{isCloning? "Cloning...": "Confirm"}</Button>
          </SpaceBetween>
        </Box>
      }
      header="Clone to other CLIs"
    >
        <SpaceBetween size={"l"}>
            <FormField description="Current Calculation Template:">
                <Popover 
                    header={`${linkedCLIs.length} CLIs linked to template`}
                    content={<div className='linkedCLIsContainer'>
                        <ColumnLayout columns={2} disableGutters>
                            {linkedCLIs.map(x => <div key={x.calculationNumber} className='verticalPadding'><LinkedCLILink linkedCLI={x}></LinkedCLILink></div>)}
                        </ColumnLayout>
                    </div>}
                >
                    {calculationTemplateMetaData?.templateName}
                </Popover>
            </FormField>
            
            <RadioGroup
                onChange={({ detail }) => setCloneType(detail.value)}
                value={cloneType}
                items={[
                    { value: "all", label: "Clone to all CLIs in the above calculation template" },
                    { value: "selected", label: "Clone to selected CLIs" }
                ]}
                />
            {cloneType === "selected" && 
                <FormField description="Clone to selected CLIs below">
                    <Multiselect 
                        loadingText='Searching CLIs...'
                        statusType={'finished'}
                        selectedOptions={selectedOptions}
                        onChange={({ detail }) => {
                            const selected = [...detail.selectedOptions];
                            setSelectedOptions(selected);
                        }}
                        deselectAriaLabel={e => `Remove ${e.label}`}
                        options={linkedCLIs.filter(x => x.calculationNumber != calculationTemplateMetaData?.calculationNumber).map(x => ({...x,
                            label: x.calculationNumber,
                            value: x.calculationNumber,
                        }))}
                        filteringType="auto"
                        placeholder={selectedOptions.length === 0?"Choose CLIs": `${selectedOptions.length} selected`}
                        selectedAriaLabel="Selected"
                        />
                </FormField>}
                {!StringUtils.isNullOrEmpty(cloneError) && <Alert type='error'>{cloneError}</Alert>}
        </SpaceBetween>
        
    </Modal>
}